import { Div } from '@codesuma/baseline'
import { IPhoneReminder } from '../../../services/phone-reminders'
import { toFaDigits } from '../../../helpers/digits'
import { PhoneMark } from '../../../components/phone-mark'
import style from './index.module.css'

// Material Design check icon (Apache 2.0), inheriting currentColor.
const CHECK_SVG = '<svg viewBox="0 0 24 24" fill="currentColor" aria-hidden="true"><path d="M9 16.17 4.83 12l-1.42 1.41L9 19 21 7l-1.41-1.41z"/></svg>'

// One of the phone's reminders in the day's list, dressed as a task beside
// Emrouz's own: the ring, the title with a small phone after it, and the hour
// when it has one. Read only — the ring says whether it is done but does not
// change it — so the whole row is one tap, which emits 'open': the Reminders
// app is where a reminder is changed.
export const ReminderRow = (reminder: IPhoneReminder) => {
    const base = Div()
    base.addClass(style.task)
    if (reminder.done) base.addClass(style.taskDone)
    base.attr('role', 'button')
    base.attr('tabindex', '0')
    base.attr('aria-label', `${reminder.title}، در برنامه‌ی یادآورها باز می‌شود`)
    base.el.onclick = () => base.emit('open')
    base.el.addEventListener('keydown', (e: KeyboardEvent) => {
        if (e.key === 'Enter' || e.key === ' ') {
            e.preventDefault()
            base.el.click()
        }
    })

    const row = Div()
    row.addClass(style.taskRow)
    base.append(row)

    // The task's ring, drawn but not pressed: it sits in the same column, so
    // the two kinds line up down the page.
    const ring = Div()
    ring.addClass(style.tick)
    ring.attr('aria-hidden', 'true')
    const inner = Div()
    inner.addClass(style.tickRing)
    inner.html(CHECK_SVG)
    ring.append(inner)
    row.append(ring)

    const title = Div(reminder.title)
    title.addClass(style.taskTitle)
    title.append(PhoneMark())
    row.append(title)

    if (reminder.time) {
        const time = Div(toFaDigits(reminder.time))
        time.addClass(style.taskTime)
        row.append(time)
    }

    return base
}
